import React, { useState } from 'react';
import { titoloFase, coloreFase } from '../../../../components/planning/fasiPlanning';

const MobilePlanningView = ({
  matches,
  maxTurno,
  maxCampo,
  getMatchAtPosition,
  getMatchWinner,
  getMatchColor,
  fasiRaggruppate
}) => {
  const [expandedTurnos, setExpandedTurnos] = useState(new Set());

  const toggleTurno = (turno) => {
    const newExpanded = new Set(expandedTurnos);
    if (newExpanded.has(turno)) {
      newExpanded.delete(turno);
    } else {
      newExpanded.add(turno);
    }
    setExpandedTurnos(newExpanded);
  };

  /** La fase a cui appartiene il turno, con il nome che le ha dato chi ha scritto la formula. */
  const getTurnoFase = (turno) =>
    fasiRaggruppate.find((faseInfo) => faseInfo.turni.includes(turno)) ?? null;

  const getMatchesForTurno = (turno) => {
    const turnoMatches = [];
    for (let campo = 1; campo <= maxCampo; campo++) {
      const match = getMatchAtPosition(turno, campo);
      if (match) {
        turnoMatches.push({ ...match, campo });
      }
    }
    return turnoMatches;
  };

  return (
    <div className="qrp-mobile-planning-container">
      {Array.from({ length: maxTurno }, (_, i) => {
        const turno = i + 1;
        const isExpanded = expandedTurnos.has(turno);
        const turnoMatches = getMatchesForTurno(turno);
        const faseInfo = getTurnoFase(turno);
        // quante ne sono gia' state battute: e' il risultato a dire che la partita e' inserita
        const inserite = turnoMatches.filter((m) => m.risultato).length;

        return (
          <div key={turno} className="qrp-turno-expander">
            <div
              className="qrp-turno-header"
              style={{ '--fase-colore': coloreFase(faseInfo?.fase) }}
              onClick={() => toggleTurno(turno)}
            >
              <div className="qrp-turno-info">
                <h3>Turno {turno}</h3>
                <span className="qrp-turno-phase">
                  {faseInfo ? titoloFase(faseInfo) : 'Non definita'}
                </span>
                <span className="qrp-turno-matches-count">
                  <strong>{`${inserite}/${turnoMatches.length}`}</strong> partite
                </span>
              </div>
              <div className={`qrp-expander-icon ${isExpanded ? 'expanded' : ''}`}>
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>
            
            {isExpanded && (
              <div className="qrp-turno-content">
                {turnoMatches.length > 0 ? (
                  <div className="qrp-turno-matches">
                    {turnoMatches.map((match, index) => (
                      <div 
                        key={`${turno}-${match.campo}-${index}`}
                        className="qrp-mobile-match-card"
                        style={{ 
                          background: getMatchColor(match),
                          border: match.risultato ? '2px solid #333' : 'none'
                        }}
                      >
                        <div className="qrp-match-header-mobile">
                          <span className="qrp-match-campo">Campo {match.campo}</span>
                          <span className="qrp-match-girone">{match.nome}</span>
                          {getMatchWinner(match) && (
                            <div className="qrp-match-winner-badge">
                              {getMatchWinner(match)}
                            </div>
                          )}
                        </div>
                        
                        <div className="qrp-match-teams-mobile">
                          <div className="qrp-teams-single-row">
                            <div className="qrp-team-name-left">
                              {match.squadra1}
                            </div>
                            <div className="qrp-score-center">
                              {match.risultato ? 
                                `${match.risultato.mete1}-${match.risultato.pieni1}-${match.risultato.vuoti1} vs ${match.risultato.mete2}-${match.risultato.pieni2}-${match.risultato.vuoti2}` : 
                                ' '
                              }
                            </div>
                            <div className="qrp-team-name-right">
                              {match.squadra2}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="qrp-no-matches">
                    Nessuna partita programmata per questo turno
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MobilePlanningView;